<div
  class="container m-b-20"
  fxLayout="row"
  fxLayout.lt-md="column"
  fxLayoutAlign="end"
  fxLayoutGap="2%"
>
  <button
    mat-raised-button
    color="primary"
    (click)="editAppUser()"
    matomoClick="Edit User Details"
    category="User Management"
    name="Edit User Button"
    [value]="userData.id"
  >
    <fa-icon icon="edit"></fa-icon>&nbsp;&nbsp;
    {{ "USER_DETAILS.EDIT" | translate }}
  </button>
  <button
    mat-raised-button
    color="warn"
    (click)="delete()"
    matomoClick="Delete User"
    category="User Management"
    name="Delete User Button"
    [value]="userData.id"
  >
    <fa-icon icon="trash"></fa-icon>&nbsp;&nbsp;
    {{ "USER_DETAILS.DELETE" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="changePassword()"
    matomoClick="Change User Password"
    category="User Management"
    name="Change Password Button"
    [value]="userData.id"
  >
    <fa-icon icon="cog"></fa-icon>&nbsp;&nbsp;
    {{ "USER_DETAILS.CHANGE_PASSWORD" | translate }}
  </button>

  <button
    mat-raised-button
    color="primary"
    (click)="deactivate()"
    *ngIf="userData.enabled"
    matomoClick="Deactivate User"
    category="User Management"
    name="Deactivate User Button"
    [value]="userData.id"
  >
    <fa-icon icon="toggle-off"></fa-icon>&nbsp;&nbsp;
    {{ "USER_DETAILS.DEACTIVATE" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="activate()"
    *ngIf="!userData.enabled"
    matomoClick="Activate User"
    category="User Management"
    name="Activate User Button"
    [value]="userData.id"
  >
    <fa-icon icon="toggle-on"></fa-icon>&nbsp;&nbsp;
    {{ "USER_DETAILS.ACTIVATE" | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div fxLayout="row wrap" class="content">
        <div fxFlex="50%" class="mat-body-strong">
          {{ "USER_DETAILS.LOGIN_NAME" | translate }}
        </div>

        <div fxFlex="50%">
          {{ userData.username }}
        </div>

        <div fxFlex="50%" class="mat-body-strong">
          {{ "USERS.FIRST_NAME" | translate }}
        </div>

        <div fxFlex="50%">
          {{ userData.firstname }}
        </div>

        <div fxFlex="50%" class="mat-body-strong">
          {{ "USERS.LAST_NAME" | translate }}
        </div>

        <div fxFlex="50%">
          {{ userData.lastname }}
        </div>

        <div fxFlex="50%" class="mat-body-strong">
          {{ "USERS.EMAIL" | translate }}
        </div>

        <div fxFlex="50%">
          {{ userData.email }}
        </div>

        <div fxFlex="50%" class="mat-body-strong">
          {{ "USER_DETAILS.OFFICE" | translate }}
        </div>

        <div fxFlex="50%">
          {{ userData.officeName }}
        </div>

        <div fxFlex="50%" class="mat-body-strong">Roles</div>

        <div fxFlex="50%">
          <span *ngFor="let role of userRoles">
            {{ role }}
          </span>
        </div>

        <div fxFlex="30%" class="mat-body-strong">
          Assigned Country Currencies
        </div>

        <div fxFlex="50%">
          <span *ngFor="let currency of userData.currencies">
            {{ currency }}
          </span>
        </div>
        <div fxFlex="20%">
          <button
            mat-raised-button
            color="primary"
            (click)="editCurrencies()"
            matomoClick="Edit User Currencies"
            category="User Configuration"
            name="Edit Currencies Button"
            [value]="userData.id"
          >
            <fa-icon icon="edit"></fa-icon>&nbsp;&nbsp; Edit
          </button>
        </div>

        <div fxFlex="30%" class="mat-body-strong">Assigned AMS</div>

        <div fxFlex="50%">
          <span *ngFor="let payeePartyIdType of userData.payeePartyIdTypes">
            {{ payeePartyIdType }}
          </span>
        </div>
        <div fxFlex="20%">
          <button
            mat-raised-button
            color="primary"
            (click)="editPayePartyIdTypes()"
            matomoClick="Edit User AMS"
            category="User Configuration"
            name="Edit AMS Button"
            [value]="userData.id"
          >
            <fa-icon icon="edit"></fa-icon>&nbsp;&nbsp; Edit
          </button>
        </div>

        <div fxFlex="30%" class="mat-body-strong">Assigned Shop/Account ID</div>

        <div fxFlex="50%">
          <span *ngFor="let payeePartyId of userData.payeePartyIds">
            {{ payeePartyId }}
          </span>
        </div>

        <div fxFlex="20%">
          <button
            mat-raised-button
            color="primary"
            (click)="editPayePartyIds()"
            matomoClick="Edit User Shop/Account ID"
            category="User Configuration"
            name="Edit Shop/Account ID Button"
            [value]="userData.id"
          >
            <fa-icon icon="edit"></fa-icon>&nbsp;&nbsp; Edit
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
